<!-- 轮播图组件 -->
<template>
    <el-carousel height="146px">
        <el-carousel-item v-for="(item, index) in bannerlist" :key="index">
            <img class="banner" @click="openUrl(item)" :src="item.adurl" alt="">
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: ['bannerlist'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        openUrl(item) {
            if(item.clickurl){
                window.open(item.clickurl)
            }
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .el-carousel {
        .el-carousel__arrow {
            display: none;
        }
        .banner {
            width: 260px;
            height: 146px;
        }
        .el-carousel__indicators {
            .el-carousel__indicator {
                .el-carousel__button {
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                }
                &.is-active {
                    .el-carousel__button {
                        background: #409EFF;
                    }
                }
            }
        }
    }
</style>